import React from 'react'
import './RecentOrders.css'
import OrdersListTab from '../OrdersListTab/OrdersListTab'
import { useDashboardData } from '../../../Context/DashboardContext/dashboardContext';

const RecentOrders = ({heading}) => {
  const {recentOrders } = useDashboardData();
  return (
    <div className='recent-orders-main-container'>
      <h3>{heading}</h3>
      <div className='recent_orders'>
        {recentOrders && recentOrders?.map((item)=>{
          return (
            <OrdersListTab item={item} items={item?.items} oid={item.uid} is_new={item.new_order} name={item.billing.first_name+ " "+item.billing.last_name} dateTime={item.createdAt} total={item.total} status={item.status} />
          )
        })}
      </div>
    </div>
  )
}

export default RecentOrders
